
import { useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';

export const BaseInputPassword = ({ name, label, control, errors }) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};
	return (
		<BaseInputValidation
			control={control}
			name={name}
			label={label}
			errors={errors}
			config={{ type: showPassword ? 'text' : 'password' }}
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						<IconButton aria-label='toggle password visibility' onClick={handleClickShowPassword} edge='end'>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};
